// extracted by mini-css-extract-plugin
export default {"panelsContainer":"CustomerPageContent_panelsContainer__NnLUy","syncScheduleTitle":"CustomerPageContent_syncScheduleTitle__QTcp5"};